export const getCompletedJobCards = (cards) => {
    let days = [];
    cards.forEach(stat => {
        days.push(stat.day)
    });
    let uniqueDays = [...new Set(days)]

    let quantity = [];
    uniqueDays.forEach((uD) => {
        const uniqueDayStat = cards.filter((s) => s.day === uD)

        quantity.push(parseInt(uniqueDayStat.length))
    })

    return {
        uniqueDays,
        quantity
    }
}